import {Navigate, Route, Routes} from "react-router-dom";
import NotFound from "../screen/NotFound";
import HomeScreen from "../screen/HomePage";
import PaymentScreen from '../screen/Payment';

const AdministratorRoute = () => {
  return (
    <Routes>
      <Route path="/" element={<Navigate to={"home"} />} />
      <Route path="/home" element={<HomeScreen />} />
      <Route path="/payment/shaparak/factor" element={<PaymentScreen.Shaparak.RedirectScreen />} />
      <Route path="/*" element={<NotFound />} />
    </Routes>
  );
};

export default AdministratorRoute;
